export default __webpack_public_path__ + "static/ma-gleason-balthazaurus-scroll-2c925a9a21d4ad78df4b13a703d99a91.mp4";